import { InvoiceAvaliable } from './invoice-avaliable'
import { InvoiceDelayed } from './invoice-delayed'
import { InvoiceReview } from './invoice-review'

export const InvoiceIsa = {
  InvoiceAvaliable,
  InvoiceReview,
  InvoiceDelayed
}
